import { FlatList } from 'react-native';
import styled from 'styled-components/native';

import Separator from '@src/components/Separator';
import {
  idKeyExtractor,
  maxWidth,
  padding,
} from '@src/configuration/constants';
import { Journey, Post, Suggestion } from '@src/types';

export const Container = styled.SafeAreaView`
  width: 100%;
  flex: 1;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  align-self: center;
`;

export const PostList = styled(FlatList as new () => FlatList<Post>).attrs(
  () => ({
    removeClippedSubviews: true,
    scrollEventThrottle: 8,
    initialNumToRender: 1,
    maxToRenderPerBatch: 1,
    keyExtractor: idKeyExtractor,
    ItemSeparatorComponent: Separator,
    contentContainerStyle: {
      paddingBottom: padding,
      maxWidth: maxWidth,
      marginHorizontal: 'auto',
      width: '100%',
      alignSelf: 'center',
    },
  })
)`
  width: 100%;
`;

export const SuggestionList = styled(
  FlatList as new () => FlatList<Suggestion>
).attrs(() => ({
  horizontal: true,
  removeClippedSubviews: true,
  keyExtractor: ({ user }) => user.id,
  showsHorizontalScrollIndicator: false,
  ItemSeparatorComponent: Separator,
  contentContainerStyle: {
    paddingHorizontal: padding,
    paddingBottom: 5,
  },
}))``;

export const JourneyList = styled(
  FlatList as new () => FlatList<Journey>
).attrs(() => ({
  horizontal: true,
  removeClippedSubviews: true,
  keyExtractor: idKeyExtractor,
  showsHorizontalScrollIndicator: false,
  ItemSeparatorComponent: Separator,
  contentContainerStyle: {
    paddingHorizontal: padding,
    paddingBottom: padding / 2,
  },
}))``;
